import { render, staticRenderFns } from "./WsPocketImagePicker.vue?vue&type=template&id=1b927152&"
import script from "./WsPocketImagePicker.vue?vue&type=script&lang=js&"
export * from "./WsPocketImagePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports